import { useEffect, useState } from "react";

import styled, { css } from "styled-components";

import { rotateAnimation } from "@sso/theme/animations";

type ToggleSwitchSize = "xs" | "sm" | "lg";

interface SwitchContainerProps {
  size?: ToggleSwitchSize;
}

interface SwitchSliderProps {
  active: boolean;
  disabled?: boolean;
  $loading?: boolean;
}
export interface ToggleSwitchPropsType {
  disabled?: boolean;
  checked?: boolean;
  loading?: boolean;
  title?: string;
  value?: boolean;
  size?: ToggleSwitchSize;
  onChange?: (status: boolean) => void;
}

const SwitchContainer = styled.div<SwitchContainerProps>`
  position: relative;
  display: inline-block;
  font-size: ${p => {
    switch (p.size) {
      case "xs":
        return "5px";
      case "sm":
        return "8px";
      case "lg":
        return "12px";
      default:
        return "10px";
    }
  }};
  width: 6em;
  height: 3.4em;
`;

const SwitchSlider = styled.span<SwitchSliderProps>`
  position: absolute;
  inset: 0;
  transition: 0.4s;
  border-radius: 3.4em;
  cursor: ${p => (p.disabled ? "not-allowed" : "pointer")};
  background-color: ${p => p.theme.colors.grey.main};

  &::before {
    position: absolute;
    content: "";
    height: 2.6em;
    width: 2.6em;
    left: 0.4em;
    bottom: 0.4em;
    background-color: ${p => p.theme.colors.background.paper};
    transition: 0.4s;
    border-radius: 50%;
  }
  &::after {
    position: absolute;
    content: "";
    height: 2em;
    width: 2em;
    left: ${p => (p.active ? "3.4em" : "0.7em")};
    bottom: 0.7em;
    transition: 0.4s;
    border-radius: 50%;
    border: 2px solid ${p => p.theme.colors.background.paper};
    border-color: transparent;
  }
  ${p =>
    p.active &&
    css`
      background-color: ${p.theme.colors.success.main};
      &::before {
        transform: translateX(2.6em);
      }
    `}
  ${p =>
    p.$loading &&
    css`
      &::after {
        border-color: ${p => p.theme.colors.primary.main} transparent;
        animation: ${rotateAnimation} 1.2s linear infinite;
      }
    `}
`;

export const Switch = ({ onChange, value, checked, loading, disabled, title, size }: ToggleSwitchPropsType) => {
  const [active, setActive] = useState(checked || false);

  useEffect(() => {
    setActive(!!value);
  }, [value]);

  const handleChangeActive = () => {
    if (!disabled) {
      onChange && onChange(!active);
      setActive(active => !active);
    }
  };

  return (
    <SwitchContainer title={title} size={size}>
      <SwitchSlider disabled={disabled} $loading={loading} active={active} onClick={value => handleChangeActive()} />
    </SwitchContainer>
  );
};
